const Hero = () => {
  return (
    <>
      <div className="absolute top-0 left-0 w-full z-0 bg-[#0f1a31]">
        <img
          src="/images/cover/1.jpeg"
          className="w-full blur-sm opacity-30"
          alt="HERO"
        />
      </div>
    </>
  );
};
export default Hero;
